import { Component, Input, OnChanges } from '@angular/core';
import { avatarColours } from '@shared/constants/avatar-colours';

@Component({
  selector: 'app-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss'],
  standalone: false,
})
export class UserAvatarComponent implements OnChanges {
  @Input() name?: string | null;
  @Input() systemUser = false;
  @Input() size = 28;
  @Input() avatarClasses = '';

  initials = '?';
  colourClasses = 'dynamic-colour-bg dynamic-colour-shadow text-white';
  colourValue: string | null = 'var(--color-grey-blue)';
  fontSizeClass = 'text-xs';

  ngOnChanges(): void {
    this.initials = this.getInitials(this.name);
    this.colourClasses = this.systemUser
      ? 'bg-grey-mid/15 border-grey-mid text-grey-mid'
      : 'dynamic-colour-bg dynamic-colour-shadow text-white';
    this.colourValue = this.getColourValue(this.name || 'user');
    this.fontSizeClass = this.getFontSizeClass(this.size);
  }

  private getInitials(name?: string | null): string {
    const words = name?.trim().split(/\s+/).filter(Boolean) || [];

    if (words.length >= 2) {
      return `${words[0][0] || ''}${words[words.length - 1][0] || ''}`.toUpperCase();
    }

    return words[0]?.slice(0, 2).toUpperCase() || '?';
  }

  private getColourValue(seed: string): string {
    const index = Array.from(seed).reduce((sum, character) => sum + character.charCodeAt(0), 0);
    const baseColour = avatarColours[index % avatarColours.length] || 'bg-grey-blue';

    return `var(--color-${baseColour.replace('bg-', '')})`;
  }

  private getFontSizeClass(size: number): string {
    if (size >= 100) {
      return 'text-3xl';
    }

    if (size >= 56) {
      return 'text-xl';
    }

    if (size >= 38) {
      return 'text-lg';
    }

    return 'text-xs';
  }
}
